import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, Renderer2, ViewChild, inject } from '@angular/core';
import { TemaService } from 'app/core/services/tema.service';

declare function vLibras(): void;

@Component({
  selector: 'app-acessibilidade',
  standalone: false,
  templateUrl: './acessibilidade.component.html',
  styleUrls: ['./acessibilidade.component.css']
})
export class AcessibilidadeComponent implements AfterViewInit, OnDestroy {

  private readonly tema = inject(TemaService);

  //Vlibras
  vLibrasScriptElement!: HTMLScriptElement;

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.loadVLibras();

    // inicializar tooltip
    this.initTooltip();
  }

  private loadVLibras() {
    this.vLibrasScriptElement = document.createElement("script");
    this.vLibrasScriptElement.src = "https://vlibras.gov.br/app/vlibras-plugin.js";
    this.vLibrasScriptElement.async = true;
    this.vLibrasScriptElement.onload = () => this.initializeVLibras();
    document.body.appendChild(this.vLibrasScriptElement);
  }

  private initializeVLibras() {
    this.vLibras();
  }

  private vLibras(): void {
    new (window as any).VLibras.Widget('https://vlibras.gov.br/app');
  }

  // Tooltip -------------------------------------------------------

  private tooltipEl!: HTMLElement;
  private hideTimeout: any = null;

  private initTooltip() {
    const icon = this.accessibilityIcon.nativeElement as HTMLElement;

    // criar tooltip
    this.tooltipEl = this.renderer.createElement('div');
    this.tooltipEl.className = 'accessibility-tooltip';
    this.tooltipEl.innerHTML = `
    <!--<img src="/assets/images/acessibilidade-ilustracao.jpg" style="width: 35px; height: 35px;"  />-->
    <div class="label">
        <div style="font-size: 14px">Acessibilidade</div>
     </div>
`;
    this.renderer.appendChild(document.body, this.tooltipEl);
    this.renderer.setStyle(this.tooltipEl, 'position', 'fixed');
    this.renderer.setStyle(this.tooltipEl, 'z-index', '2147483647');
    this.renderer.setStyle(this.tooltipEl, 'opacity', '0');
    this.renderer.setStyle(this.tooltipEl, 'pointer-events', 'none');
    this.renderer.setStyle(this.tooltipEl, 'transition', 'opacity .18s ease');

    // EVENTO: mouse entra no ícone
    icon.addEventListener("pointerenter", () => {
      if (this.hideTimeout) clearTimeout(this.hideTimeout);
      this.positionTooltip(icon);
      this.showTooltip();
    });

    // EVENTO: mouse sai do ícone
    icon.addEventListener("pointerleave", () => {
      this.scheduleHide();
    });

    // EVENTOS: manter tooltip aberto caso mouse passe por cima do tooltip
    this.tooltipEl.addEventListener("pointerenter", () => {
      if (this.hideTimeout) clearTimeout(this.hideTimeout);
      this.showTooltip();
    });

    this.tooltipEl.addEventListener("pointerleave", () => {
      this.scheduleHide();
    });
  }

  private showTooltip() {
    this.renderer.setStyle(this.tooltipEl, 'opacity', '1');
    this.renderer.setStyle(this.tooltipEl, 'pointer-events', 'auto');
  }

  private hideTooltip() {
    this.renderer.setStyle(this.tooltipEl, 'opacity', '0');
    this.renderer.setStyle(this.tooltipEl, 'pointer-events', 'none');
  }

  private scheduleHide() {
    if (this.hideTimeout) clearTimeout(this.hideTimeout);
    this.hideTimeout = setTimeout(() => this.hideTooltip(), 120);
  }

  private positionTooltip(iconEl: HTMLElement) {
    const rect = iconEl.getBoundingClientRect();
    const tool = this.tooltipEl;

    const spacing = 10;

    const left = rect.left - tool.clientWidth - spacing;
    const top = rect.top + rect.height / 2 - tool.clientHeight / 2;

    this.renderer.setStyle(tool, 'left', `${left}px`);
    this.renderer.setStyle(tool, 'top', `${top}px`);
  }

  //--------------------------------------------------------------------

  scrollToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  showBackToTopButton = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.showBackToTopButton = scrollPosition > 20;
  }

  //acessibilidade
  @ViewChild('accessibilityIcon', { static: true }) accessibilityIcon!: ElementRef;
  @ViewChild('accessibilityMenu', { static: true }) accessibilityMenu!: ElementRef;

  toggleAccessibility() {
    const menuElement = this.accessibilityMenu.nativeElement as HTMLElement;
    menuElement.classList.toggle('is-open');
  }

  //acessibilidade texto
  aumentarTexto() {
    document.querySelectorAll('p, h1, h2, h3, h4, h5, h6, span, a')
      .forEach(el => { el.classList.add('texto-aumentado'); el.classList.remove('texto-diminuido'); });
  }

  diminuirTexto() {
    document.querySelectorAll('p, h1, h2, h3, h4, h5, h6, span, a')
      .forEach(el => { el.classList.add('texto-diminuido'); el.classList.remove('texto-aumentado'); });
  }

  restaurarPadrao() {
    document.querySelectorAll('p, h1, h2, h3, h4, h5, h6, span, a')
      .forEach(el => el.classList.remove('texto-aumentado', 'texto-diminuido'));
  }

  // Tema -----------------------------------------------------------
  // O estado do tema vive em TemaService; aqui apenas expomos o toggle
  // de modo escuro, que continua dentro do menu de acessibilidade.

  readonly modoEscuro = this.tema.modoEscuro;

  alternarModoEscuro() {
    this.tema.alternarModoEscuro();
  }

  ngOnDestroy() {
    try {
      if (this.tooltipEl && this.tooltipEl.parentNode === document.body) {
        this.renderer.removeChild(document.body, this.tooltipEl);
      }
    } catch { }
  }
}
